import { translate } from 'support/translate';
import ParentalPin from 'components/widgets/parental-pin/ParentalPin';
import { AppData } from '@lightningjs/sdk';

const TARGET_YEAR = 12;

export default class ResetParentalPin extends ParentalPin {
  protected override update() {
    this.title = translate('ParentalPin.resetPin.title');
    this.description = translate('ParentalPin.resetPin.description');
    this._PinInput.patch({ useMaskingCharacter: false });
    super.update();
  }

  override closeWidget() {
    AppData?.modalService.close();
    this.resetStates();
  }

  protected override getErrorText() {
    return translate('ParentalPin.resetPin.errorText');
  }

  override $cancel() {
    this.closeWidget();
  }

  override $validate() {
    const targetYear = new Date().getFullYear() - TARGET_YEAR;

    const enteredYear = Number(this.pin);
    if (this.pin.length === 4 && enteredYear <= targetYear) {
      // We don't call onValidate, but we do pass it
      AppData?.modalService.open('SetParentalPin', {
        replaceCurrent: true,
        data: { onValidate: this.onValidate },
      });
    } else {
      this.handleInvalidPin();
    }
  }
}
